import { useQuery } from 'react-query';

/**
 * Whether this is the demo deployment (demo.buildc.ai), read from the public health check
 * so it works before sign-in. Any failure reads as "not demo": the banner is a courtesy,
 * and what keeps the demo's email and payments inside it is enforced by the API.
 */
export function useDemoMode(): boolean {
  const { data } = useQuery(
    ['demo-mode'],
    async () => {
      const res = await fetch('/api/health');
      if (!res.ok) return false;
      const body = (await res.json()) as { demo?: boolean };
      return body.demo === true;
    },
    { staleTime: Infinity, retry: false },
  );
  return data === true;
}
